var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1665 6.5166H14.1665C13.6142 6.5166 13.1665 6.96432 13.1665 7.5166V10.5166H17.1665C17.2802 10.5141 17.3881 10.567 17.4557 10.6585C17.5233 10.75 17.5423 10.8686 17.5065 10.9766L16.7665 13.1766C16.6983 13.3785 16.5096 13.515 16.2965 13.5166H13.1665V21.0166C13.1665 21.2927 12.9426 21.5166 12.6665 21.5166H10.1665C9.89036 21.5166 9.6665 21.2927 9.6665 21.0166V13.5166H8.1665C7.89036 13.5166 7.6665 13.2927 7.6665 13.0166V11.0166C7.6665 10.7405 7.89036 10.5166 8.1665 10.5166H9.6665V7.5166C9.6665 5.30746 11.4574 3.5166 13.6665 3.5166H17.1665C17.4426 3.5166 17.6665 3.74046 17.6665 4.0166V6.0166C17.6665 6.29274 17.4426 6.5166 17.1665 6.5166Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookWhite);
export default __webpack_public_path__ + "static/media/facebookWhite.64c296cdf0b6eba837c2be8f79420d8d.svg";
export { ForwardRef as ReactComponent };